<div class="container">
    <header class="hero">
        <div class="wrap">
            <h1>
                Bouclier MACE ASSURANCE en faveur du pouvoir d’achat :
                <br/> des mesures concrètes pour nos clients
            </h1>
            <p>Nous accompagnons les professionnels ainsi que les particuliers</p>
        </div>
    </header>
    <main class="section">
        <div class="wrap">
            <div class="cards">
                <article class="card">
                    <h2>Notre expertise depuis 2005</h2>
                    <p>
                        Implantée à Auxerre, La Maison d’Assurance du Centre Est accompagne les particuliers
                        dans le choix de leurs  <span>assurances auto, habitation et santé</span>. Spécialistes du secteur
                        depuis 2005, nous mettons à votre service une équipe d’experts qualifiés qui analyse vos
                        besoins et vous conseille avec rigueur. Notre objectif : vous proposer des solutions adaptées
                        à votre situation, en tenant compte des risques et de votre budget.
                    </p>
                </article>
                <article class="card">
                    <h2>Un accompagnement personnalisé</h2>
                    <p>
                        Parce que chaque projet est unique, nous nous engageons à vous guider pas à pas dans vos
                        démarches. Nous partageons avec vous notre savoir-faire afin de vous aider à mieux comprendre
                        les coûts et les enjeux liés à vos assurances. Notre rôle est de vous offrir une vision claire
                        et transparente, pour que vous puissiez prendre vos décisions en toute confiance.
                    </p>
                </article>
                <article class="card">
                    <h2>Des solutions pour chaque étape<br>de votre vie</h2>
                    <p>
                        Vous envisagez une complémentaire santé ? Vous souhaitez protéger votre véhicule ou sécuriser
                        votre habitation ? Quelle que soit votre demande, nous restons disponibles pour vous accompagner
                        et trouver la couverture la plus adaptée. Avec La Maison d’Assurance du Centre Est, vous bénéficiez
                        d’un partenaire fiable et attentif, présent à vos côtés dans toutes les étapes de votre vie.
                    </p>
                </article>
            </div>
        </div>
        <div class="cta" (click)="nav.nav('contact')">
            <div class="btn">Contactez-nous</div>
        </div>
    </main>
</div>